import axios from "axios";
import * as AppSettingsService from "./AppSettingsService";
import {
  UserEmailAddressStatusResponse,
  UpdateEmailAddressRequest,
  UpdateEmailAddressResponse,
} from "../types/ProfileTypes";

const appSettings = AppSettingsService;

export async function DeleteServiceUser(data: any, personId: number): Promise<any> {
  try {
    const response = await axios.post(
      `${appSettings.getAppApiUrl()}/ccp/Profiling/v1/DeleteServiceUser/${personId}`,
      data,
    );
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getUserEmailAddressStatus(
  email: string
): Promise<UserEmailAddressStatusResponse> {
  try {
    const response = await axios.get(
      `${appSettings.getAppApiUrl()}/usermanagement/useradmin/v1/user?email=${email}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function updateUserEmailAddress(
  data: UpdateEmailAddressRequest
): Promise<UpdateEmailAddressResponse> {
  try {
    const response = await axios.put(
      `${appSettings.getAppApiUrl()}/usermanagement/provisioning/v1/username`,
      data
    );

    return response.data;
  } catch (error: any) {
    if ([107, 108].includes(error?.response?.data[0]?.code)) {
      throw new Error("InvalidEmail");
    } else {
      throw error;
    }
  }
}
